import "./BooleanSlider.css";

const BooleanSlider = ({
	value,
	onChange,
	disabled = false,
	loading = false,
	yesLabel = "Sim",
	noLabel = "Não",
	label = "Alternar valor",
}) => {
	const checked = Boolean(value);
	const isDisabled = disabled || loading;

	return (
		<button
			type="button"
			className={`boolean-slider ${checked ? "is-checked" : ""} ${loading ? "is-loading" : ""}`}
			role="switch"
			aria-checked={checked}
			aria-label={label}
			aria-busy={loading}
			disabled={isDisabled}
			onClick={(event) => {
				event.stopPropagation();
				onChange?.(!checked);
			}}
		>
			<span className="boolean-slider-track" aria-hidden="true">
				<span className="boolean-slider-thumb">
					{loading && <span className="boolean-slider-spinner" />}
				</span>
				<span className="boolean-slider-label boolean-slider-label-yes text-white!">
					{yesLabel}
				</span>
				<span className="boolean-slider-label boolean-slider-label-no text-white!">
					{noLabel}
				</span>
			</span>
		</button>
	);
};

export default BooleanSlider;
